import { api } from 'utility';
import { getUserInformationUrl, getUserNameServiceUrl } from 'URLs';
export function getUser() {
  return api.get(getUserInformationUrl()).then((res) => res.data);
}
export function putUser(params) {
  return api.put(getUserNameServiceUrl(), params);
}

export default {
  getUser,
  putUser,
};
